<template>
  <div class="users-edit" v-loading="loading">
    <el-checkbox v-model="form.editorApprove" @change="saveApprove" style="margin-top: 10px">Утверждение отчетов
      редактором
    </el-checkbox>
    <el-form>
      <template v-if="!form.isCompany">
        <el-form-item label="Email">
          <el-input :disabled="true" v-model="form.email" placeholder="Email"/>
        </el-form-item>
        <el-form-item label="Должность">
          <el-input v-model="form.position" placeholder="Должность"/>
        </el-form-item>
        <el-form-item label="Имя Фамилия">
          <el-input v-model="form.name" placeholder="Имя Фамилия"/>
        </el-form-item>
        <el-form-item label="Телефон">
          <el-input v-model="form.phone" placeholder="Телефон"/>
        </el-form-item>
        <el-form-item label="Компания">
          <el-input v-model="form.company" placeholder="Компания"/>
        </el-form-item>
        <div>
          <Notification v-model="form.notification" @save="saveNotification"/>
        </div>
        <el-radio-group v-model="form.role" :disabled="currentUser" style="margin-bottom: 16px">

          <el-radio label="admin">Администратор</el-radio>
          <el-radio label="editor">Редактор</el-radio>
          <el-radio label="worker">Стандартный</el-radio>
        </el-radio-group>
      </template>
      <template v-else>
        <el-form-item label="Название">
          <el-input v-model="form.company" @input="companyChange" placeholder="Название"/>
        </el-form-item>
        <el-form-item label="Комментарий">
          <el-input v-model="form.comment" type="textarea" textarea/>
        </el-form-item>
        <el-form-item label="ИНН">
          <el-input v-model="form.inn" type="number"/>
        </el-form-item>
        <el-form-item label="ФОТ">
          <el-input v-model="form.fot" type="number"/>
        </el-form-item>

        <el-form-item label="Смена">
          <el-input v-model="form.hours" type="number"/>
        </el-form-item>
        <div style="display: flex; margin-bottom: 12px">
          <div style="display: flex; margin-right: 32px">
            <el-checkbox v-model="form.is_saturday" style="margin-right: 12px">Суббота</el-checkbox>
            <el-input v-model="form.hours_saturday" type="number" style="width: 80px"/>
          </div>
          <div style="display: flex;">
            <el-checkbox v-model="form.is_sunday" style="margin-right: 12px">Воскресенье</el-checkbox>
            <el-input v-model="form.hours_sunday" type="number" style="width: 80px"/>
          </div>
        </div>
      </template>
      <div style="margin-bottom: 20px">
        <PermissionVersion v-if="form.isCompany" :id="id" :user="form" @update="updatePermission"/>
        <PermissionObject
          :plan-id="$store.state.project.plan && $store.state.project.plan.id"
          v-if="form.role !== 'worker' || form.isCompany" :id="id"
          :only-object="!form.isCompany"
          :user="permissionForm"

          @update="updatePermission"
        />
        <PermissionDocs v-if="form.isCompany" :id="id" :user="form" @update="updatePermission"/>
        <router-link :to="`/dashboard/company/users/${this.$route.params.id}`">
          <el-button
            v-if="form.isCompany"
            size="small"
            style="width: 100%; margin-bottom: 2px"
          >
            Работники
          </el-button>
        </router-link>
        <VolumesWorksJob></VolumesWorksJob>
      </div>
      <el-button
        style="width: 100%; margin-bottom: 8px"
        @click="deleteUser"
        size="small"
        type="danger"
      >
        Удалить {{ form.isCompany ? 'компанию' : 'пользователя' }} из организации
      </el-button>

      <div class="users-edit__buttons">
        <el-button @click="$router.go(-1)">Отмена</el-button>
        <el-button type="primary" @click="save(false)">Сохранить</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import firebase from 'firebase';
import PermissionObject from "./PermissionObject";
import PermissionDocs from "./PermissionDocs";
import Notification from "./Notification";
import PermissionVersion from "./PermissionVersion";
import VolumesWorksJob from "./company/VolumesWorksJob";

export default {
  name: 'Edit',
  components: {VolumesWorksJob, PermissionVersion, Notification, PermissionDocs, PermissionObject},
  data() {
    return {
      loading: false,
      id: null,
      form: {
        editorApprove: false,
        notification: {
          enabled: false,
          time_shift: [
            {
              time: null,
              current_day: false
            },
            {
              time: null,
              current_day: false
            },
            {
              time: null,
              current_day: false
            }
          ],
          week: [true, true, true, true, true, false, false]
        },
        name: '',
        inn: '',
        position: '',
        role: 'admin',
        email: '',
        phone: '',
        company: '',
        fot: '',
        isCompany: false,
        comment: '',


        available_objects: [],
        available_jobs: {},
        available_docs: [],
        available_files: {},
        available_versions: [],
        plan_permission: {}
      },
    };
  },

  mounted() {
    this.fetchUser();
  },

  computed: {
    currentUser() {
      return authFirestore.currentUser.uid === this.form.uid;
    },
    permissionForm() {
      if(this.$store.state.project.plan && this.$store.state.project.plan.id) {
        try {
          return this.form.plan_permission[this.$store.state.project.plan.id] || {
            available_objects: [],
            available_jobs: {},
            usePermission: false,
          }
        } catch (e) {
          return {
            available_objects: [],
            available_jobs: {},
            usePermission: false,
          }
        }
      }

      return this.form
    }
  },

  methods: {
    companyChange() {
      this.form.name = this.form.company.trim();
    },
    saveNotification() {
      this.save()
    },
    saveApprove() {
      myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('users')
        .doc(this.id)
        .update({
          editorApprove: this.form.editorApprove
        })
    },
    deleteUser() {
      this.$confirm(`Вы действительно хотите удалить ${this.form.isCompany ? 'компанию' : 'пользователя'} из организации?`,
        'Подтверждение',
        {
          confirmButtonText: 'Да',
          cancelButtonText: 'Нет',
          type: 'warning',
        }).then(async () => {
        await myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('users')
          .doc(this.$route.params.id)
          .delete()

        const responseData = await myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id).get();
        const data = responseData.data();
        delete data.rules[this.form.uid || this.$route.params.id];
        myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .update(
            {
              ...responseData.data(),
              rules: {
                ...data.rules,
              },
            },
          ).then(() => {
          this.$router.push('/dashboard/users');
          this.$notify({
            offset: 60,

            title: 'Успех',
            message: 'Пользователь удален',
            type: 'success',
          });
        });
      });
    },
    fetchUser() {
      this.loading = true;
      myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('users')
        .doc(this.$route.params.id).get()
        .then((subDoc) => {
          this.id = subDoc.id;
          this.form = {
            ...this.form,
            ...subDoc.data(),
            role: subDoc.data().role,
          };
        }).finally(() => {
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    updatePermission(user) {
      if (this.$store.state.project.plan && this.$store.state.project.plan.id) {
        this.form = {
          ...this.form,
          plan_permission: {
            ...user.plan_permission,
            [this.$store.state.project.plan.id]: {
              available_jobs: user.available_jobs,
              available_objects: user.available_objects,
              usePermission: user.usePermission,
            }
          }
        }
      } else {
        this.form = user
      }

      Object.keys(localStorage)
        .filter(key => key.startsWith('PERM'))
        .map(key => localStorage.removeItem(key))

      Object.keys(localStorage)
        .filter(key => key.startsWith( 'USER'))
        .map(key => localStorage.removeItem(key))
    },
    async save(flag) {
      this.loading = true;
      myFirestore.collection('projects').doc(this.$store.state.project.id).get().then(async (response) => {
        const responseData = response.data();
        await myFirestore.collection('projects').doc(this.$store.state.project.id).update(
          {
            ...responseData,
            rules: {
              ...responseData.rules,
              [this.form.uid || this.$route.params.id]: this.form.role,
            },
          },
        );
      });
      myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('users')
        .doc(this.id)
        .update({
          ...this.form,
          company: this.form.company.trim()
        }).then((add) => {
        if (!flag) {
          this.$notify({
            offset: 60,

            title: 'Успешно',
            message: 'Данные пользователя изменены',
            type: 'success',
          });


          if (this.currentUser) {
            setTimeout(() => {
              window.location.reload()
            }, 1000);
          } else {
            setTimeout(() => {
              this.$router.push('/dashboard/users');
            });
          }
          return
        }

        this.$notify({
          offset: 60,
          title: 'Успешно',
          message: 'Данные об уведомлениях изменены',
          type: 'success',
        });
      }).catch((error) => {
        this.$notify({
          offset: 60,

          title: 'Упс... ',
          message: 'Произошла ошибка повторите позже',
          type: 'error',
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
.users-edit {
  max-width: 472px;
  width: calc(100% - 40px);
  margin: 42px auto;
  padding-bottom: 50px;

  @media screen and (max-width: 764px) {

    .el-radio-group {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;

      .el-radio {
        margin-bottom: 10px;
      }
    }
  }

  &__buttons {
    margin-top: 28px;
    justify-content: space-between;
    width: 100%;
    flex: 1;
    display: flex;

    &:before {
    }

    &:after {
    }
  }

  .input-line-container {
    display: flex;
    justify-content: space-between;
    width: 100%;
    flex: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Users/Edit.vue